"use client";

import React, { useState } from "react";
import styled from "styled-components";
import { blockPadding, blockPaddingTop, Box } from "@motorata/base-ui.components.atoms._atoms";
import { Label, LabelH2, P, Title } from "@motorata/base-ui.components.atoms.typography";
import { CalculateParamsType, CalculateType } from "@motorata/base-ui.types.api";
import CalculationBlock from "@motorata/base-ui.components.shared.calculation-block";
import Button from "@motorata/base-ui.components.atoms.button";
import List from "@motorata/base-ui.components.molecules.list";
import SuccessModal from "@/components/modals/SuccessModal";
import CalculatorModal from "@/components/modals/CalculatorModal";

const FinanceHeader = ({ initValue = 85000, type = "leasing", subtitle, title, text, list, image }: {
  initValue?: number
  type?: "leasing" | "credit"
  subtitle?: string
  title?: any
  text?: string
  list?: string[]
  image?: string
}) => {
  const [state, setState] = useState<CalculateParamsType>();
  const [showModal, setShowModal] = useState<string | null>(null);
  const [calculation, setCalculation] = useState<CalculateType>();

  const handleCalculationParamsChange = (e: CalculateParamsType) => {
    setState(e);
    // AnalyticsService.track("Finance Calculator Calculation", {
    //   page: type,
    //   ...e
    // });
  };

  return (
    <>
      <Wrapper className="background">
        <TextWrapper>
          <Label margin="0" marginBottom="S" color="primary" fontSize="L" fontWeight="normal" textTransform="uppercase">
            {subtitle}
          </Label>
          <StyledH2 fontWeight="extraBold">{title}</StyledH2>
          <P maxWidth="500px" marginTop="S">
            {text}
          </P>
          {
            list &&
            <List
              mt="M"
              list={list}
            />
          }
        </TextWrapper>

        {/*<ImageWrapper>*/}
        {/*  <Image priority={true} alt={`Grafika ${title}`} height={500} width={1000} src={image} />*/}
        {/*</ImageWrapper>*/}
        <FormWrapper>
          <Title elementType="label" label="Online">Oblicz ratę finansowania</Title>
          <CalculationBlock
            initParams={{
              type: type,
              price: initValue
            }}
            showRepurchase={true}
            showPriceType={false}
            onChangeParams={handleCalculationParamsChange}
            onChangeCalculation={setCalculation}
          />
          <Button width="100%" onClick={() => setShowModal("contact")}>
            Otrzymaj bezpłatną ofertę
          </Button>
        </FormWrapper>
      </Wrapper>
      {state && calculation && (
        <CalculatorModal
          type={type}
          state={state}
          calculation={calculation}
          show={showModal === "contact"}
          setShow={setShowModal}
        />
      )}
      <SuccessModal show={showModal === "success"} setShow={setShowModal} image="/images/send.png" />
    </>
  );
};

export default FinanceHeader;

const StyledH2 = styled(LabelH2)`
  display: block !important;
  font-size: 45px !important;;
  line-height: 55px !important;;
  max-width: 600px !important;;
  font-weight: ${({ theme }) => theme.font.extraBold} !important;;

  span {
    font-size: 45px !important;;
    line-height: 55px !important;;
    font-weight: inherit !important;;
    color: ${({ theme }) => theme.color.primary} !important;;
  }

  @media (max-width: 600px) {
    font-size: 30px !important;;
    line-height: 40px !important;;

    span {
      font-size: 30px !important;;
      line-height: 40px !important;;
    }
  }
`

const FormWrapper = styled(Box)`
  margin-top: ${({ theme }) => theme.space.M};
  width: 40%;
  min-height: 500px;
  border-radius: 10px;
  background: white;
  padding: ${({ theme }) => theme.space.M};
  box-shadow: ${({ theme }) => theme.variable.boxShadow};
`;

const ImageWrapper = styled.div`
  width: 100%;
  max-width: 800px;

  img {
    width: 100%;
    height: auto;
    filter: drop-shadow(5px 5px 30px rgba(0, 0, 0, 0.1));
  }
`;

const PartnerLogoWrapper = styled(Box)`
  width: 100px;
  height: 50px;
`;

const TextWrapper = styled.div`
  ${blockPaddingTop};
  display: flex;
  flex-direction: column;

  @media (max-width: 900px) {
    padding-top: ${({ theme }) => theme.space.M};
  }
`;

const Wrapper = styled.div`
  ${blockPadding};
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: -${({ theme }) => theme.space.XXL};
  grid-gap: ${({ theme }) => theme.space.M};

  @media (max-width: 800px) {
    margin-top: -${({ theme }) => theme.space.XL};
  }

  @media (max-width: 1000px) {
    display: block;

    > div {
      width: 100%;
    }
  }
`;
